import { ALL_PLANS } from 'my-core/subscription-utils';

import SubscriptionPlanItem from './SubscriptionPlanItem';

const rootCss = ({ breakpoints, spacing }) => ({
  display: 'flex',
  minWidth: 0,
  justifyContent: 'center',
  gap: spacing(2),
  '.SPI-plan': { flex: '1 0 0', minWidth: 230, maxWidth: 350, width: 260 },
  [breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
});

export default function SubscriptionPlanItems({
  allSelected,
  className,
  disabled,
  onClick,
  plansCtaProps,
  product,
  selectedPlan,
}) {
  return (
    <div className={className} css={rootCss}>
      {ALL_PLANS.map(plan => (
        <SubscriptionPlanItem
          key={plan}
          className="SPI-plan"
          ctaProps={plansCtaProps?.[plan]}
          disabled={disabled}
          onClick={onClick}
          plan={plan}
          product={product}
          selected={allSelected || selectedPlan === plan}
        />
      ))}
    </div>
  );
}
